<template>
  <div class="h-100">
    <!-- Status Timeline-->
    <div class="col-md-12 mt-3" v-if="bookingReq.status && bookingReq.status.length > 0">
      <div class="col-md-12 ">
        <h6>{{ $t("message.Request status") }}</h6>
      </div>
      <div class="col-md-12">
        <el-timeline>
          <el-timeline-item v-for="(status, index) in bookingReq.status" size='large' :key="index" icon="el-icon-check" :timestamp="getDatetime(status.timestamp,false)">
            {{status.status}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <!-- Health Package -->
    <div v-if="bookingReq && bookingReq.healthPackage" class="col-md-12 mt-3">
      <div class="col-md-12">
        <h6>{{ $t("message.Health Package") }}</h6>
      </div>
      <div>
        <div class="labtest-card">
          <card>
            <div class="">
              <p>{{ bookingReq.healthPackage.name }}</p>
            </div>
          </card>
        </div>
      </div>
    </div>

    <!-- Preferred Date Range -->
    <div v-if="bookingReq && bookingReq.preferredDateRange" class="col-md-12 mt-3">
      <div class="col-md-12">
        <h6>{{ $t("message.Preferred Date") }}</h6>
      </div>
      <div>
        <div class="labtest-card">
          <card>
            <div class="">
              <p>
                <span>{{ getDatetime(bookingReq.preferredDateRange.from,true) }}</span>
                <span class="pl-1 pr-1">{{ $t("message.To")  }}</span>
                <span>{{ getDatetime(bookingReq.preferredDateRange.to,true) }}</span>
              </p>
            </div>
          </card>
        </div>
      </div>
    </div>

    <!-- Lab Details -->
    <div class="col-md-12 pb-5" v-if="lab">
      <div class="col-md-12">
        <h6>{{(bookingReq && bookingReq.latestStatus == 'Scheduled') ? $t("message.Lab Details") :$t("message.Preferred Lab Details") }}</h6>
      </div>
      <card>
        <div class="col-md-12 pl-0">
          <div class="row">
            <div class="col-md-1 col-3 text-center">
              <span>
                <i class="fa fa-microscope"></i>
              </span>
            </div>
            <div class="col-md-8 col-9 pl-0">
              <span>{{lab.name}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-1 col-3 text-center">
              <span>
                <i class="fa fa-map-marker-alt"></i>
              </span>
            </div>
            <div class="col-md-8 col-9 pl-0" v-if="lab.location && lab.location.addressDetails">
              <span>{{lab.location.addressDetails.address}}</span>
            </div>
          </div>
          <div class="col-12 text-center" v-if="(bookingReq && bookingReq.latestStatus == 'Scheduled') && lab && lab.location && lab.location.addressDetails && lab.location.addressDetails.geolocation && lab.location.addressDetails.geolocation.coordinates">
            <n-button type="primary" class="btn-padding light mr-2" round @click.native="navigate()" simple>
              <i slot="label" class="fa fa-route pr-2"></i>
              {{  $t("message.Navigate") }}
            </n-button>
          </div>

        </div>

      </card>
    </div>
    <n-button v-if="bookingReq && bookingReq.latestStatus == 'Pending'" type="primary" style="margin: 0px;margin: 0px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 5%;" class="btn-padding light mr-2" round @click.native="cancelHealthCheckupRequest(bookingReq)">
      <i class="now-ui-icons ui-1_simple-remove pr-1"></i>
      {{ $t("message.Cancel") }}
    </n-button>
  </div>
</template>


<script>
export default {
  name: "viewHealthCheckupRequest",
  data() {
    return {
      lab: null,
    };
  },
  async mounted() {
    console.log(this.bookingReq);
    if (this.bookingReq && this.bookingReq.preferredLab) {
      let response = await this.$store.dispatch(
        "getEndpointDetails",
        this.bookingReq.preferredLab
      );
      if (response && response._id) {
        this.lab = response;
      }
    }
  },
  computed: {
    bookingReq() {
      return this.$store.state.bookingReq;
    },
  },
  methods: {
    getDatetime(timestamp, onlyDate) {
      if (onlyDate) {
        return moment(Number(timestamp)).format("DD-MM-YYYY");
      } else {
        return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
      }
    },
    async cancelHealthCheckupRequest(request) {
      swal
        .fire({
          title: this.$t("message.Are you sure that you want to cancel this request?"),
          confirmButtonText: this.$t("message.Yes"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            try {
              let res = await this.$store.dispatch("getBookingReq", {
                requestId: request._id,
              });
              this.$store.commit('setState', {
                stateName: 'bookingReq', stateValue: res
              });


              if (res && res._id && res.latestStatus == "Pending") {
                await this.$store.dispatch("updateHealthCheckupRequestStatus", {
                  requestId: request._id,
                  status: "Cancelled",
                });

                socket.emit("healthCheckupRequestCancelled", {
                  caregroupId: this.user.caregroup._id || this.user.caregroup,
                  healthCheckupRequestId: res._id,
                });

                swal.fire({
                  title: this.$t("message.Health checkup request cancelled successfully!"),
                  type: "success",
                  timer: 3000,
                });

                this.$router.push("ahc");
              } else {
                swal.fire({
                  title: this.$t("message.Error, couldn't cancel the request!"),
                  text: this.$t("message.Health package is approved"),
                  type: "error",
                  timer: 3000,
                });
              }
            } catch (err) {
              console.log(err);
              swal.fire({
                title: this.$t("message.Error, couldn't cancel the request!"),
                type: "error",
                timer: 3000,
              });
            }
          }
        });
    },
    navigate() {
      let geocoords = "";

      let coordinates =
        this.lab.location.addressDetails.geolocation.coordinates;
      geocoords = coordinates[1] + "," + coordinates[0];

      if (device.platform == "iOS") {
        window.open("maps://?q=" + geocoords, "_system");
      } else {
        window.open("geo:0,0?q=" + geocoords, "_system");
      }
    },
  },
};
</script>
<style scoped>
/deep/.tab-content {
  height: calc(100% - 68px);
  /* for fixed buttons from bottom */
  position: relative;
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}
.status-update-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.el-timeline {
  padding-left: 2em;
}

/deep/.el-timeline-item__icon {
  color: #18ce0f;
}

/deep/.el-timeline-item__node {
  background: white;
  border: solid 1px #18ce0f;
  padding: 0.8em;
  left: -7px;
}
/deep/.el-timeline-item {
  padding-bottom: 30px;
}

/deep/.el-timeline-item__timestamp {
  font-size: 11px;
}
.laborder-passcode {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
}
</style>

